import { useSiteContent } from "@/hooks/useSiteContent";
import { Clock, Award, IndianRupee } from "lucide-react";

export function WhyUs() {
  const { content } = useSiteContent();
  const items = [
    { icon: Clock, title: content.why_1_title, desc: content.why_1_desc },
    { icon: Award, title: content.why_2_title, desc: content.why_2_desc },
    { icon: IndianRupee, title: content.why_3_title, desc: content.why_3_desc },
  ];
  return (
    <section id="why" className="py-20 md:py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold uppercase tracking-wider text-accent">Trusted by Mansa</p>
          <h2 className="mt-2 text-3xl md:text-4xl">{content.why_title}</h2>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {items.map((it, i) => (
            <div key={i} className="rounded-2xl border border-border bg-card p-8 text-center shadow-card-soft transition-smooth hover:shadow-elegant">
              <div className="mx-auto inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-accent-soft text-primary">
                <it.icon className="h-8 w-8" />
              </div>
              <h3 className="mt-5 text-xl">{it.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
